import AttributesHeader from "./AttributesHeader";
import PageTitleWrapper from "src/components/PageTitleWrapper";
import { Grid, Container, Card } from "@mui/material";
import Footer from "src/components/Footer";
import AttributesContent from "./AttributesContent";

function Attributes() {
  return (
    <>
      <title>Attributes</title>
      <PageTitleWrapper>
      <AttributesHeader />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              <AttributesContent />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default Attributes;
